import { useShellCreateAction } from '@ordo/ui/app-shell'
import { Badge } from '@ordo/ui/badge'
import { Button } from '@ordo/ui/button'
import { ServerDataGrid } from 'compositions/DataGrid'
import { Page } from 'compositions/Page'
import { ShowInactiveToggle } from 'compositions/ShowInactiveToggle'
import { Plus } from 'lucide-react'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import type { Column } from 'types/data-grid'
import type { Layout } from 'types/layouts'

const COLUMNS: Column<Layout>[] = [
  {
    key: 'name',
    header: 'Name',
    sortable: true,
    filterable: true,
    render: (row) => (
      <span>
        {row.name}
        {!row.active && (
          <Badge variant="outline" className="ml-2 text-xs">
            Inactive
          </Badge>
        )}
      </span>
    ),
  },
  {
    key: 'updatedAt',
    header: 'Last Modified',
    width: '30%',
    sortable: true,
    render: (row) => new Date(row.updatedAt).toLocaleDateString(),
  },
]

export function LayoutList() {
  const navigate = useNavigate()
  // On phones "New Layout" is the shell's floating + button; the header button is desktop only.
  useShellCreateAction({ label: 'New Layout', onCreate: () => navigate('/layouts/new') })
  const [includeInactive, setIncludeInactive] = useState(false)
  const params = useMemo(() => ({ includeInactive }), [includeInactive])

  return (
    <Page>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold">Layouts</h1>
        <div className="flex items-center gap-4">
          <ShowInactiveToggle checked={includeInactive} onCheckedChange={setIncludeInactive} />
          <Button className="hidden md:inline-flex" onClick={() => navigate('/layouts/new')}>
            <Plus className="h-4 w-4" />
            New Layout
          </Button>
        </div>
      </div>
      <ServerDataGrid<Layout>
        endpoint="/api/layouts"
        params={params}
        columns={COLUMNS}
        keyField="id"
        storageKey="layouts"
        searchPlaceholder="Search layouts…"
        onRowClick={(row) => navigate(`/layouts/${row.id}`)}
      />
    </Page>
  )
}
